import { render, staticRenderFns } from "./ColumnChartView.vue?vue&type=template&id=724eed8f&"
import script from "./ColumnChartView.vue?vue&type=script&lang=js&"
export * from "./ColumnChartView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports